'use client';
import { FC, useState } from 'react';
import classNames from 'classnames';
import './ImageListingCard.scss';
import MainBodyToReact from '../MainBodyToReact';
import Link from 'next/link';
import CustomImage from '@/components/CustomImage/CustomImage';

interface ImageListingCardProps {
    title: string;
    subtitle: Document | undefined;
    image: string;
    buttonText: string;
    link: string;
    target: string;
}

const ImageListingCard: FC<ImageListingCardProps> = ({
    title,
    subtitle,
    image,
    buttonText,
    link,
    target,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className="card tw-cursor-pointer tw-relative"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Link href={link} target={target} className="tw-absolute tw-size-full tw-z-20" />

            <div className="image-container">
                <CustomImage
                    src={image}
                    alt={title}
                    fill
                    sizes="(max-width: 576px) 443px"
                    className="tw-object-cover"
                />
            </div>
            <div className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-end tw-p-4 tw-z-10">
                <h4
                    className="
                tw-opacity-80
                tw-font-gotham-medium
                tw-uppercase
                tw-text-[#FFFFFF]
                tw-text-[12px]
                tw-mb-[8px]
                "
                >
                    <MainBodyToReact
                        body={subtitle}
                        classes={{ p: '!tw-pb-0 tw-font-gotham-medium tw-font-light tw-text-sm' }}
                    />
                </h4>
                <h3
                    className="
                tw-font-gotham-bold
                lg:tw-w-4/5
                md:tw-mb-[10px]
                tw-text-white
                tw-text-[24px]
                md:tw-text-[26px]
                loading-10
                "
                >
                    {title}
                </h3>
                <Link
                    className={classNames('button-white', { 'button-white-active': isHovered })}
                    href={link}
                    target={target}
                >
                    {buttonText}
                </Link>
            </div>
        </div>
    );
};

export default ImageListingCard;
